/* Delivery estimate under the add to cart button: working days from today, weekends skipped. */
(function () {
  function addWorkingDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function run() {
    document.querySelectorAll('[data-ls-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      if (!min || !max) return;
      var now = new Date(), a = addWorkingDays(now, min), b = addWorkingDays(now, max);
      var dm = { day: 'numeric', month: 'short' };
      var fa = a.toLocaleDateString('en-GB', a.getMonth() === b.getMonth() ? { day: 'numeric' } : dm);
      var fb = b.toLocaleDateString('en-GB', dm);
      var span = el.querySelector('span');
      if (span) span.textContent = 'Order today and it arrives ' + fa + ' to ' + fb;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
